import React from "react";
import { useIntl } from "react-intl";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import { ReactComponent as TickIcon } from "src/images/tick.svg";

export default function InfluencerInterestInput({
  influencerInterestValueInput,
  onChangeInfluencerInterestValueInput,
  isDisabled,
  onKeyPress,
  label,
}) {
  const intl = useIntl();
  return (
    <div className="cdt-search-input">
      <div className="idh-label idh-label--with-tooltip">
        {label}
        <MaterialTooltip
          id="front_audience_interests_tooltip_bottom"
          content={
            <>
              <IDHFormattedMessage
                id="front_influencer_interests_tooltip_top"
                defaultMessage="Interests are determined by analyzing captions, @mentions, #hashtags, and locations used by the creator in the latest 150 posts (or more, if they all have been published within the last 2 months) and compared with Instagram users on average. Additionally, the following factors are taken into consideration:"
              />
              <br />
              <br />
              <div className="tooltip-content-wrapper">
                <TickIcon className="tooltip-tick" />
                <IDHFormattedMessage
                  id="front_audience_interests_tooltip_bottom_a"
                  defaultMessage={`Brand Affinity aspect - For example, if a person mentioned "McDonald’s", "KFC", this indicates interest in food. `}
                />
              </div>
              <div className="tooltip-content-wrapper">
                <TickIcon className="tooltip-tick" />
                <IDHFormattedMessage
                  id="front_audience_interests_tooltip_bottom_b"
                  defaultMessage={`Other food-related keywords, such as "food", "cakes" etc.`}
                />
              </div>
            </>
          }
        />
      </div>
      <input
        placeholder={intl.formatMessage({
          id: "front_search_topic_placeholder",
          defaultMessage: "Search topic...",
        })}
        value={influencerInterestValueInput}
        onKeyPress={onKeyPress}
        onChange={onChangeInfluencerInterestValueInput}
        disabled={isDisabled}
        data-cdt-input="creator-interests"
      />
    </div>
  );
}
